module.exports = __webpack_public_path__ + "static/media/buy-our-vintage-design-items-online-at-zo-goed-als-oud-com.71758c4f.jpg";